export const DEFAULT_SELECTED_COMPARISON_CARD_TAB_ID = 'energy-savings';
